import styled from 'styled-components';

export const SelectWrapper = styled.div`
  position: relative;
  height: 57px;
  font-family: ${props => props.theme.typography.fontFamily};
`;

export const ValueText = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const labelWithValue = props => props.hasValue && `
  height: 9px;
  margin-bottom: 8px;
  font-size: 10px;
  color: ${props.theme.carvana.blue.primary};
`;

export const SelectLabel = styled.label<{
  hasValue: boolean;
  disabled: boolean;
}>`
  height: 14px;
  margin-bottom: 5px;

  color: ${props => props.theme.carvana.gray.dark};
  color: ${props => props.disabled && props.theme.carvana.gray.medium};
  font-size: 14px;
  font-weight: 700;
  text-align: left;

  cursor: pointer;
  transition: font-size 200ms ease-out, color 200ms ease-out;
  ${labelWithValue}
`;

export const IconWrapper = styled.div`
  width: 10px;
  height: 15px;
  margin-right: 8px;
  color: ${props => props.theme.carvana.blue.primary};
`;

const visibleDropdown = p => p.showDropdown && `
  border: 1px solid transparent;
  border-radius: 3px 3px 0px 0px;
  box-shadow: 0 7px 13px 1px rgba(24, 41, 60, 0.1);
  border-bottom: 1px solid ${p.theme.carvana.gray.medium};
`;

export const SelectMenuDefault = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  width: 100%;
  margin: 0;

  background-color: ${props => props.theme.carvana.white.primary};
  border: 1px solid ${props => props.theme.carvana.gray.light};
  border-radius: 3px;
  cursor: pointer;

  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  text-align: left;
  text-transform: uppercase;

  &:disabled {
    background-color: transparent;
    color: ${props => props.theme.carvana.gray.light};
    svg {
      color: ${props => props.theme.carvana.gray.light};
    }
    label {
      color: ${props => props.theme.carvana.gray.light};
    }
  }

  &:focus {
    outline: 0;
    border-color: ${props => props.theme.carvana.white.primary};
    box-shadow: 0 7px 13px 1px rgba(24, 41, 60, 0.1);
    border-radius: 3px 3px 0 0;
    border-bottom: 1px solid ${props => props.theme.carvana.gray.light};
  }

  &:focus-within ${SelectLabel} {
    color: ${props => props.theme.carvana.gray.dark};
  }

  &:focus-within ${IconWrapper} {
    color: ${props => props.theme.carvana.blue.primary};
  }

  ${visibleDropdown}
`;

export const SelectLabelDefault = styled.div`
  display: flex;
  flex-flow: column;
  padding: 0 12px;
  padding-left: 10px;
  min-width: 0;
  color: ${props => props.theme.carvana.gray.dark};
`;

export const DropdownMenuDefault = styled.div`
  position: absolute;
  display: block;
  width: 100%;
  z-index: 1;
  max-height: 245px;

  background-color: ${props => props.theme.carvana.white.primary};
  border-radius: 0px 0px 3px 3px;
  box-shadow: 0 7px 13px 1px rgba(24, 41, 60, 0.1);
  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 6px;
    background-color: ${props => props.theme.carvana.gray.light};
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 8px;
    background-color: ${props => props.theme.carvana.blue.dark};
  }

  &::-webkit-scrollbar-track {
    border-radius: 8px;
    background-color: ${props => props.theme.carvana.gray.light};
  }
`;

export const DropdownItemDefault = styled.div<{
  isSelected: boolean;
}>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 13px 18px 19px;

  color: ${props => props.theme.carvana.blue.dark};
  color: ${props => props.isSelected && props.theme.carvana.gray.medium};
  font-size: 14px;
  font-weight: 700;
  text-align: left;
  cursor: pointer;

  &:hover {
    background-color: ${props => props.theme.carvana.blue.dark};
    color: ${props => props.theme.carvana.white.primary};
  }
`;
